import axios from 'axios';
import ResponseErrorHandel from "../ReponseErrorHandeler/StatusHandel.js";



const apiRequests = axios.create({
    baseURL: 'https://bot-messenger.maksiran.ir',
    headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`
    },
    // timeout: 5000,
})

export default apiRequests;


apiRequests.interceptors.request.use(
    config => {

        // if (config.data)
        return config;
        // else {
        //     config = {
        //         status: 147,
        //         message: "data is empty",
        //         response: {
        //             status: 47,
        //             message: "null"
        //         }
        //     }
        //     return config;
        // }
    },
    error => {

        return Promise.reject(error)
    }
)


apiRequests.interceptors.response.use(
    (res) => {

        return res
    },

    error => {
        ResponseErrorHandel(error)
        return Promise.reject(error)

    }
)



